import Moods from './Moods';

export default Moods;



// WEBPACK FOOTER //
// ./src/components/Moods/index.js